import React from "react";
import Context from "../../../context/Context";
import * as component from "../../util/component";

export default class LevelFilter extends React.Component {

  constructor(props) {
    super(props);
    this.facilityRef = React.createRef()
    this.state = component.newState({
      facilityId: this.props.facilityId,
      levelId: this.props.levelId,
      siteId: this.props.siteId
    });
  }

  componentDidMount() {
    if (this.props.onMount) this.props.onMount(this);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  onChange(data) {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const levelsDataset = Context.instance.aiim.datasets.levels;
    const datasets = Context.instance.aiim.datasets;
    const isSitesLayer = datasets && datasets.sites;    
    const facilityId = this.state.facilityId;
    const levelId = this.state.levelId;
    const siteId = this.state.siteId;

    const siteSelected = evt => {
      const v = evt.target.value || null;
      if(v !== siteId) {
        const data = {
          siteId: v,
          facilityId: null,
          levelId: null
        };
        this.setState(data);
      }
    }

    const facilitySelected = evt => {
      const v = evt.target.value || null;
      const data = {
        facilityId: v
      };
      if (levelId && !v) {
        data.levelId = null;
      }
      if (levelId && v) {
        const ld = levelsDataset && levelsDataset.getLevelData(levelId);
        if (!ld || ld.facilityId !== v) {
          data.levelId = null;
        }
      }
      this.setState(data);
    };

    const facilityClicked = evt => {
      facilitySelected(evt);
    };

    const levelSelected = evt => {
      const v = evt.target.value || null;
      this.setState({
        levelId: v
      })
    };

    const levelClicked = evt => {
      levelSelected(evt);
    };

    let facilities = levelsDataset && levelsDataset.getFacilities();
    let facilitiesA = [];
    if(facilities && facilities.length > 0) {
      facilities.forEach((facility)=> {
        if (!siteId || siteId === facility.siteId) {
          facilitiesA.push(facility);
        }
      })
    }

    // filter facilities and levels depending on site selected (cascading)
    // const levels = [], facilitiesA = [];
    // if (facilities && facilities.length > 0) {
    //   facilities.forEach(f => {
    //     if (!siteId || siteId === f.siteId) {
    //       facilitiesA.push({
    //         name : f.facilityName,
    //         value: f.facilityId
    //       })
    //     }
    //     if (!facilityId || facilityId === f.facilityId) {
    //       f.levels.forEach(l => {
    //         levels.push({
    //           name: l.levelShortName,
    //           value: l.levelId
    //         })
    //       });
    //     }
    //   });
    // }

    //sites to be displayed in the sites filter
    let sites = new Set(), siteOptions = [];
    if(facilities && facilities.length > 0) {
      facilities = facilities.slice();
      facilities.sort((a,b) => {
        if (a.siteName && b.siteName) {
          return a.siteName.localeCompare(b.siteName);
        }
        return 0;
      });
      siteOptions.push(
        <option key="empty" value="">
          {i18n.meetingRooms.any}
        </option>
      );
      facilities.forEach(facility => {
        if(!sites.has(facility.siteId)){
          sites.add(facility.siteId);
          siteOptions.push( 
          <option key={facility.siteId} value={facility.siteId}>
            {facility.siteName}
          </option>)
        }
      })
    }

    // facilities
    let facilityOptions;
    const levels = [];
    if (facilitiesA && facilitiesA.length > 0) {
      facilitiesA.sort((a,b) => {
        if (a.name && b.name) {
          return a.name.localeCompare(b.name);
        }
        return 0;
      });
      facilityOptions = [];
      facilityOptions.push(
        <option key="empty" value="">
          {i18n.meetingRooms.any}
        </option>
      );
      facilitiesA.forEach(f => {
        if (facilityId && facilityId === f.facilityId) {
          f.levels.forEach(l => {
            levels.push({
              name: l.levelShortName,
              value: l.levelId
            })
          });
        }
        facilityOptions.push(
          <option key={f.facilityId} value={f.facilityId}>
            {f.facilityName}
          </option>
        );
      });
    }

    // levels to be displayed depending facility selected
    let levelOptions = [], removeDuplicates = new Set();
    levelOptions.push(
      <option key="empty" value="">
        {i18n.meetingRooms.any}
      </option>
    );
    if (levels && levels.length > 0) {
      levels.sort((a,b) => {
        if (a.name && b.name) {
          return a.name.localeCompare(b.name);
        }
        return 0;
      });
      levels.forEach(level => {
        if(!removeDuplicates.has(level.name)) {
          removeDuplicates.add(level.name);
          levelOptions.push(
            <option key={level.value} value={level.value}>
              {level.name}
            </option>
          );
        }
      });
    }

    return (
      <div>
        {isSitesLayer && siteOptions && siteOptions.length > 1 && 
           <div>
           <label>
             <div>{i18n.meetingRooms.filterOptions.site}</div>
             <select defaultValue={siteId} 
                className="i-filter-select"
                onBlur={siteSelected} 
                onClick={siteSelected} onKeyUp={siteSelected}>
               {siteOptions}
             </select>
           </label>
         </div>
        }
        {facilityOptions &&
          <div>
            <label>
              <div>{i18n.meetingRooms.filterOptions.facility}</div>
              <select defaultValue={facilityId}
                className="i-filter-select"
                onBlur={facilitySelected}
                onClick={facilityClicked} onKeyUp={facilityClicked}>
                {facilityOptions}
              </select>
            </label>
          </div>
        }
        {levelOptions &&
          <div>
            <label>
              <div>{i18n.meetingRooms.filterOptions.level}</div>
              <select defaultValue={levelId} onBlur={levelSelected}
                className="i-filter-select"
                onClick={levelClicked} onKeyUp={levelClicked}
                disabled={levelOptions.length === 1}>
                {levelOptions}
              </select>
            </label>
          </div>
        }
      </div>
    );
  }

  validate(criteriaPart) {
    let ok = true;
    criteriaPart.facilityId = this.state.facilityId;
    criteriaPart.levelId = this.state.levelId;
    criteriaPart.siteId = this.state.siteId;
    return ok;
  }

}
